exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-align[data-v-63f730da]{text-align:right}", ""]);

// exports
